export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///wAA+PgAAOXl5SH5BAAAAAAALAAAAAASAAwAAAIdlI+py+2vgpy02ouz3naAD4YiMHjj+ZUoWrbu+xYAOw=="